/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Button, Flex, Text, Image } from "@aws-amplify/ui-react";

export default function CustomPricingPlanList(props) {
  const { pricingRef, navigateToSignup, overrides, ...rest } = props;

  const plans = [
    {
      name: 'Business plan',
      price: '$79/mo',
      pricingDetails: 'Billed monthly',
      features: ['Track key sales metrics and customer traffic patterns to optimize your strategy.', 'Corporate Sales Analytics: Understand trends in high-volume orders to refine your business decisions.', 'Access up to two years of historical data to analyze long-term performance and identify growth opportunities.']
    },
    {
      name: 'Enterprise plan',
      price: '$109/mo',
      pricingDetails: 'Billed monthly',
      features: ['Predict future sales with data-driven models to improve inventory and financial planning.', 'Select your forecast horizon for more accurate projections from 6 custom models.', 'Gain insights into data from up to 23 Amazon marketplaces, helping you track trends and optimize your strategy on a global scale.']
    }
  ];


  const pricingStyle = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center', // Centers the container horizontally
      justifyContent: 'center', // Centers the container vertically
      fontFamily: 'Arial, sans-serif',
      paddingLeft: '80px',
      paddingRight: '80px',
      paddingBottom: '50px',
      backgroundColor: '#F8F8F8',
      lineHeight: 'normal',
      height: '100vh', // Ensures the container takes up the full viewport height
    },
    plansContainer: {
      display: 'flex',
      justifyContent: 'center', // Centers the plans horizontally
      alignItems: 'flex-start', // Aligns the plans to the top
      gap: '20px', // Reduces the gap between the plans
      marginTop: '20px',
      width: '100%', // Ensures the container spans the full width
    },
    plan: {
      borderRadius: '8px',
      padding: '35px',
      width: '45%', // Reduces the width of each plan to fit them side by side
      textAlign: 'center',
      display: 'block',
      backgroundColor: 'white',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    price: {
      fontSize: '1.9em',
      fontWeight: 'bold',
      margin: '10px 0',
    },
    button: {
      marginTop: '2px',
      padding: '1px 2px',
      backgroundColor: '#00607a',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      width: '100%',
      cursor: 'pointer',
    },
    featuresList: {
      textAlign: 'left',
      paddingLeft: '0',
      listStyleType: 'none',
      marginTop: '30px',
      display: 'block',
    },
    featureItem: {
      display: 'flex',
      marginBottom: '15px',
      alignItems: 'center',
    },
    pricingText: {
      fontSize: '1.2em',
      marginTop: '30px',
      fontWeight: '700',
      color: '#00607A',
    },
    choosePlanText: {
      marginTop: '10px',
      fontWeight: 'bold',
      fontSize: '1.9em',
    },
    choosePlanDescription: {
      marginTop: '10px',
      fontSize: '1.0em',
      color: '#5C6670',
      marginBottom: '15px',
    },
    planName: {
      color: '#00607A',
      fontWeight: 'bold',
      fontSize: '1.0em',
    },
    pricingDetails: {
      color: '#5C6670',
    },
    featureIcon: {
      height: '20px', // Reduced size for the icon
      width: '20px',  // Reduced size for the icon
      marginRight: '10px', // Adds spacing between the icon and text
    },
  };

  
  const logoStyle = {
    height: '40px'
};

  return (
    <Flex
      style={pricingStyle.container}
      ref={pricingRef}
      {...getOverrideProps(overrides, "PricingSection")}
      {...rest}
    >
      <Text
        style={pricingStyle.pricingText}
        children="Pricing"
        {...getOverrideProps(overrides, "PricingText")}
      />
      <Text
        style={pricingStyle.choosePlanText}
        children="Choose your plan"
        {...getOverrideProps(overrides, "ChoosePlanText")}
      />
      <Text
        fontFamily="Inter"
        style={pricingStyle.choosePlanDescription}
        children=""
        {...getOverrideProps(overrides, "ChoosePlanDescription")}
      />
      <Flex
        style={pricingStyle.plansContainer}
      >
        {plans.map((plan, index) => (
          <Flex
            key={index}
           
            style={pricingStyle.plan}
            {...getOverrideProps(overrides, `Plan-${index}`)}
          >
            <Text
              as="span"
              fontFamily="Inter"
              style={pricingStyle.planName}
              children={plan.name}
              {...getOverrideProps(overrides, `PlanName-${index}`)}
            />
            <Text
              fontFamily="Inter"
              style={pricingStyle.price}
              children={plan.price}
              {...getOverrideProps(overrides, `Price-${index}`)}
            />
            <Text
              fontFamily="Inter"
              style={pricingStyle.pricingDetails}
              children={plan.pricingDetails}
              {...getOverrideProps(overrides, `PricingDetails-${index}`)}
            />
            <Flex as="ul" style={pricingStyle.featuresList}>
              {plan.features.map((feature, i) => (
                <Flex
                  key={i}
                  as="li"
                  style={pricingStyle.featureItem}
                  {...getOverrideProps(overrides, `FeatureItem-${index}-${i}`)}
                >
                  <Image
                    src="feature-check-icon.png"
                    alt=""
                    style={pricingStyle.featureIcon}
                    {...getOverrideProps(overrides, `FeatureIcon-${index}-${i}`)}
                  />
                  <Text
                    fontFamily="Inter"
                    as="span"
                    style={pricingStyle.featureText}
                    children={feature}
                    {...getOverrideProps(overrides, `FeatureText-${index}-${i}`)}
                  />
                </Flex>
              ))}
            </Flex>
            <Button
              style={pricingStyle.button}
              onClick={navigateToSignup}
              children="Get Started with 7 days free"
              {...getOverrideProps(overrides, `GetStartedButton-${index}`)}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}
